import fetch from 'cross-fetch';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Trans, withTranslation } from 'react-i18next';
import NavBar, { BackButton, NextButton } from './NavBar2.jsx';

class PrepaidDeviceActivationForm extends Component {
  state = {
    isLoading: false,
    errorCode: null,
  }

  handleSubmit = () => {
    const { onNext } = this.props;
    const { deviceEmei } = this.props.values;

    this.setState({ isLoading: true });

    this.activateDevice(deviceEmei)
      .then((activateJson) => {
        this.setState({ isLoading: false });
        onNext({ devicePlatform: activateJson.devicePlatform });
      })
      .catch((e) => {
        this.setState({
          isLoading: false,
          errorCode: e,
        });
      });
  };

  activateDevice = deviceEmei => fetch('/sessions/me/activate-device', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      /** No additional params needed because this device is prepaid, and should have a factory set promo code */
      deviceEmei,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        // TODO: Need more informative error
        throw new Error('Failed to activate device');
      }


      return response.json();
    });

  prepaidDurationDescription = (durationDays) => {
    // 20Sep24: Just convert days to number of months rounded. That should do fine.
    // 365 -> 12 months
    // 60 -> 2 months
    // 5 -> 5 days

    if (durationDays < 30) {
      return `${durationDays} days`;
    }

    const numMonths = Math.floor(durationDays / 30);
    return numMonths === 1 ? '1 month' : `${numMonths} months`;
  }

  render() {
    const { onBack, t } = this.props;
    const { prepaidDurationDays } = this.props.values;

    return (
      <div>
        <h2>{t('prepaid_device_activation_form.title')}</h2>
        <div>
          <p className="form-text text-muted">
            <Trans
              i18nKey="activation_wizard:prepaid_device_activation_form.paragraph_1"
              values={{
                prepaidDurationDescription: this.prepaidDurationDescription(prepaidDurationDays),
              }} />
          </p>

          <p className="form-text text-muted">
            {t('prepaid_device_activation_form.paragraph_2')}
          </p>
        </div>

      <NavBar>
          <NextButton
            isLoading={this.state.isLoading}
            onClick={this.handleSubmit}
            disabled={false}
            label={t('prepaid_device_activation_form.activate_button_label')}
          />
          <BackButton onClick={onBack} />
      </NavBar>
      </div>
    );
  }
}

PrepaidDeviceActivationForm.propTypes = {
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  values: PropTypes.object,
  handleChange: PropTypes.func,
};


export default withTranslation('activation_wizard')(PrepaidDeviceActivationForm);
